// extracted by mini-css-extract-plugin
export default {"container":"src-views-common-containers-SnapTraySnapList-SnapTraySnapList__container--YYwgW"};